/**
 * @generated SignedSource<<ec4cb61f89a8b7c9856da7d05930ff1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ReportStatus = "DRAFT" | "ERROR" | "PENDING" | "PROCESSING" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ReportsTableRow_report$data = {
  readonly id: string;
  readonly rowId: any;
  readonly kind: string;
  readonly name: string;
  readonly status: ReportStatus;
  readonly createdAt: any;
  readonly deletedAt: any | null;
  readonly company: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ReportSources_report" | "ReportContextMenu_report">;
  readonly " $fragmentType": "ReportsTableRow_report";
};
export type ReportsTableRow_report$key = {
  readonly " $data"?: ReportsTableRow_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportsTableRow_report">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportsTableRow_report",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportSources_report"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportContextMenu_report"
    }
  ],
  "type": "Report",
  "abstractKey": null
};
})();

(node as any).hash = "417b484b8f7a703ded6c20b53aea44a3";

export default node;
